import React from 'react'
import { SVGProps } from 'react'

const UserIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8 8C10.2091 8 12 6.20914 12 4C12 1.79086 10.2091 0 8 0C5.79086 0 4 1.79086 4 4C4 6.20914 5.79086 8 8 8Z" />
    <path d="M8 9.33276C4.68781 9.33645 2.00369 12.0206 2 15.3328C2 15.701 2.29847 15.9994 2.66666 15.9994H13.3333C13.7015 15.9994 14 15.701 14 15.3328C13.9963 12.0206 11.3122 9.33642 8 9.33276Z" />
  </svg>
)
export default UserIcon
